









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'Loading',
})
export default class Loading extends Vue {

  // Refs
  public $refs!: {
    spinner: HTMLElement,
  };

  // Props
  @Prop({default: 'medium'}) private size: string | undefined;
  @Prop({default: true}) private showBackground: boolean | undefined;

  // Data
  private mediumSize: string = '8vh';
  private smallSize: string = '4vh';

  // Hooks
  private mounted() {
    const spinnerSize = (this.size === 'medium') ? this.mediumSize : this.smallSize;
    this.$refs.spinner.style.width = spinnerSize;
    this.$refs.spinner.style.height = spinnerSize;
  }
}
